import coverUrl from "./upload-cover-pic.html";
import profileUrl from "./upload-profile-pic.html";

export const uploadCoverPicComponent = {
  bindings: {
    pageName: "@",
    onUpload: "&",
    type: "@",
    footerText: "@",
    defaultCoverPic: "@",
    coverPhotoRequired: "@",
    showRoundedPic: "@",
    isDisable: "<",
    disableSubmit: "&",
    headingText: "@",
    onRemove: "&",
    cropModalDetails: "<",
  },
  template: '<div ng-include="$ctrl.templateUrl">',
  controller: class UploadCoverPicComponent {
    constructor(
      toastr,
      $parse,
      $timeout,
      ApiService,
      ImageCropService,
      FileUploadService,
      ImageUploadService
    ) {
      "ngInject";
      this.$parse = $parse;
      this.toastr = toastr;
      this.$timeout = $timeout;
      this.apiService = ApiService;
      this.imageCropService = ImageCropService;
      this.fileUploadService = FileUploadService;
      this.imageUploadService = ImageUploadService;
    }

    $onInit() {
      this.footerText =
        this.footerText || "Accepted Formats: PNG, JPG. Max 10 mb";
      this.coverPhotoRequired =
        typeof this.coverPhotoRequired === "boolean"
          ? this.coverPhotoRequired
          : this.$parse(this.coverPhotoRequired || "false")(false);
      this.title = this.coverPhotoRequired
        ? "Cover Photo"
        : "Cover Photo (optional)";
      this.imageSrc = this.defaultCoverPic || this._getDefaultPath();
      this.selectedImage = this.defaultCoverPic;
      if (this.defaultCoverPic) {
        this.coverPhotoRequired = false;
      }
      this.templateUrl = this.showRoundedPic ? profileUrl : coverUrl;
      this.type = this.type
        ? this.type
        : this.showRoundedPic
        ? "profile"
        : "cover";
      if (this.headingText) {
        this.title = this.headingText;
      }
    }
    _getDefaultPath() {
      if (this.showRoundedPic) {
        return "/./images/profile-img.png";
      }
      return "/./images/cover-pic.jpg";
    }
    onFileChange() {
      const pattern = /^image/g;
      const isImage = pattern.test(this.selectedImage.type);
      if (this.selectedImage && isImage) {
        this.imageCropService.cropImage({
          image: this.selectedImage,
          onCrop: _upload.bind(this),
          onCancel: _onCancel.bind(this),
          type: this.type,
          modal: this.cropModalDetails,
        });
      } else {
        this.toastr.error("Invalid image file");
      }

      function _onCancel() {
        if (this.defaultCoverPic === "") {
          this.selectedImage = "";
        }
      }

      function _upload(image) {
        this.disableSubmit();
        this.imageUploadService
          .upload({
            image: image,
            name: this.selectedImage.name,
            container: this.pageName,
          })
          .then((response) => {
            const _details = response.data.details;
            this.imageSrc = this.apiService.getImageUrl(_details.uuid);
            this.onUpload({
              $event: {
                details: _details,
              },
            });
          })
          .catch(({ data }) => {
            this.toastr.error(data.errors.message);
          });
      }
    }
    _onRemove() {
      this.fileName = "";
      this.selectedImage = "";
      this.defaultCoverPic = "";
      this.hideRemove = true;
      this.imageSrc = this._showSqurePhoto
        ? "/./images/profile-img.png"
        : "/./images/cover-pic.jpg";
      this.coverPhotoRequired = this.coverPhotoRequired;
      this.onRemove();
    }
    $onChanges(changes) {
      if (changes.defaultCoverPic) {
        this.imageSrc = this.apiService.getImageUrl(
          changes.defaultCoverPic.currentValue
        );
      }
      if (changes.coverPhotoRequired) {
        this.coverPhotoRequired = this.$parse(
          changes.coverPhotoRequired.currentValue || "false"
        )(false);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/upload-cover-pic/upload-cover-pic.component.js